import { jsx } from "react/jsx-runtime";
import { TextAreaFieldWUT } from "../../../ui/text-area-field/text-area-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const TextAreaWUT = (props) => {
  const fieldType = FIELD_TYPES.TEXT_AREA;
  return /* @__PURE__ */ jsx(TextAreaFieldWUT, { ...props, fieldType });
};
export {
  TextAreaWUT
};
//# sourceMappingURL=text-area-wut.js.map
